export const BEPI_PERMISSIONS = {
    MOBCHECK_ADMIN: {
        client: true,
        workshop: true,
        admin: true,
        canAssignBepiRoles: true
    },
    SERVICE_ADMIN: {
        client: true,
        workshop: true,
        admin: true,
        canAssignBepiRoles: true
    },
    SERVICE_WORKSHOP: {
        client: false,
        workshop: true,
        admin: false,
        canAssignBepiRoles: false
    },
    SERVICE_CLIENT: {
        client: true,
        workshop: false,
        admin: false,
        canAssignBepiRoles: false
    }
};

export function getBepiPermissions(role) {
    return BEPI_PERMISSIONS[role] || {
        client: false,
        workshop: false,
        admin: false,
        canAssignBepiRoles: false
    };
}
